import { useEffect } from 'react';

export default function usePageAnimations(selector: string) {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'auto' });
    const elements = Array.from(document.querySelectorAll<HTMLElement>(selector));

    elements.forEach((element, index) => {
      element.classList.add('page-reveal');
      element.style.setProperty('--reveal-delay', `${(index % 8) * 55}ms`);
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('page-reveal-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -35px' });

    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
  }, [selector]);
}
